import en from './en.json';
import ru from './ru.json';

import { flattenMessages } from './flatten';

export const translations = {
    en: flattenMessages(en),
    ru: flattenMessages(ru),
} as const;